import React, { useEffect, useState } from "react";
import Circle2 from "./Circle2.js";
import classes from "./TeamLineups2.module.css";

const GRIDS = ["1","2","3","4","5"];

const PlayerCell = ({ data, colorChange }) => {
    const { player } = data;
    return (
        <div className={classes.center_items}>
            <div className={classes.item}>
                <Circle2 number={player?.number} count={player?.count} colorChange={colorChange} />
                <p className={classes.player_name}>{player.name}</p>
            </div>
        </div>
    );
};

const TeamLineups2 = ({ homeTeam, startXI }) => {
    const [grids, setGrids] = useState({ g1:[], g2:[], g3:[], g4:[], g5:[] });

    useEffect(() => {
        setGrids({
            g1: startXI?.filter(d => d?.player?.grid?.startsWith("1")) ?? [],
            g2: startXI?.filter(d => d?.player?.grid?.startsWith("2")) ?? [],
            g3: startXI?.filter(d => d?.player?.grid?.startsWith("3")) ?? [],
            g4: startXI?.filter(d => d?.player?.grid?.startsWith("4")) ?? [],
            g5: startXI?.filter(d => d?.player?.grid?.startsWith("5")) ?? [],
        });
    }, [startXI]);

    // Home team: rows 1→5 top-to-bottom; Away team: rows 5→1 top-to-bottom
    const rowOrder = homeTeam
        ? [grids.g1, grids.g2, grids.g3, grids.g4, grids.g5]
        : [grids.g5, grids.g4, grids.g3, grids.g2, grids.g1];

    return (
        <div className={classes.team_container}>
            {rowOrder.map((row, i) => (
                <div
                    key={i}
                    className={classes.sub_container}
                    style={{ display: "grid", gridTemplateColumns: `repeat(${row.length}, 1fr)` }}
                >
                    {row.map((data, j) => (
                        <PlayerCell key={j} data={data} colorChange={!homeTeam} />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TeamLineups2;